<template>
    <div>
        <rkm-form
            ref="Form"
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        :options="unidades"
                        label="Unidade solicitante"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="unidade.unidadeSolicitanteId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="unidade.unidadeSolicitanteInfraestruturaId"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="unidadeColeta"
            sortBy="unidadeSolicitante"
            ref="Table"
            hide-filters
        >
            <template v-slot:cell(unidadeSolicitante)="row">
                <span>{{ row.item.unidadeSolicitante }}</span>
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(index, item)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Mixins.
import { object } from '@/mixins'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    mixins: [ object ],
    computed: {
        fields() {

            const fields = [
                {
                    key: 'unidadeSolicitante',
                    label: 'Unidade solicitante',
                    sortable: true
                },
                {
                    key: 'infraestruturaNome',
                    label: 'Local de atendimento',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]

            return fields
        },
        unidades() {

            return this.isUnidadesSolicitantes
                ? this.data.model.unidadesSolicitantes
                    .map(unidade => {
                        return {
                            ...unidade,
                            id: unidade.unidadeId
                        };
                    })
                    .sort((a, b) => {
                        return a.nomeFantasia.localeCompare(b.nomeFantasia);
                    })
                : this.data.form.unidades
        },
        isUnidadesSolicitantes() {

            return this.data.model.unidadesSolicitantes && this.data.model.unidadesSolicitantes.length > 0
        },
        infraestruturas() {
            if (this.unidade.unidadeSolicitanteId) {

                let unidadeSolicitante = this.isUnidadesSolicitantes
                    ? this.unidades.filter(u => u.id === this.unidade.unidadeSolicitanteId)
                    : this.unidades.find(u => u.id === this.unidade.unidadeSolicitanteId)

                if (unidadeSolicitante) {

                    let infraestruturas = this.isUnidadesSolicitantes
                        ? this.unificarInfraestruturasPorUnidade(unidadeSolicitante)
                        : unidadeSolicitante.infraestruturas

                    if (infraestruturas) {

                        this.getPrincipal(infraestruturas);

                        return infraestruturas
                    }
                }
            }

            return [];
        },
    },
    created() {

        this.load()
    },
    methods: {
        load() {

            const hasSetor = this.unidadeColeta
                .find(cc => cc.unidadeSolicitanteId === this.unidadeId
                    && cc.unidadeSolicitanteInfraestruturaId === this.infraestruturaId)

            if (hasSetor || this.unidadeDisabled) {

               return false
            }

            const unidade = this.clone(this.unidade)

            const unidadeSelecionada = this.unidades.find(s => s.id === this.unidadeId)

            if (unidadeSelecionada) {

                unidade.unidadeSolicitante = unidadeSelecionada.nomeFantasia

                const infraestruturaSelecionada = this.isUnidadesSolicitantes
                    ? this.unidades.find(s => s.id === this.infraestruturaId)
                    : unidadeSelecionada.infraestruturas.find(s => s.id === this.infraestruturaId)

                if (infraestruturaSelecionada) {

                    unidade.infraestruturaNome = infraestruturaSelecionada.nome

                    unidade.unidadeSolicitanteId = this.unidadeId
                    unidade.unidadeSolicitanteInfraestruturaId = this.infraestruturaId
                    unidade.infraestruturaId = this.infraestruturaId
                    unidade.unidadeId = this.unidadeId
                    unidade.unidadeTipoId = this.enums.tipoUnidade.COLETA

                    this.unidadeColeta.push(unidade)

                    this.resetForm()
                }
            }
        },
        unificarInfraestruturasPorUnidade(unidadeSolicitante) {

            return unidadeSolicitante
                .filter(infra => infra.unidadeId === this.unidade.unidadeSolicitanteId)
                .map(curr => {
                    return {
                        id: curr.infraestruturaId,
                        nome: curr.infraestruturaNome,
                        principal: curr.infraestruturaPrincipal,
                        urgencia: curr.urgencia
                    };
                });
        },
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    const unidade = this.clone(this.unidade)

                    unidade.unidadeSolicitante = this.unidades
                        .find(s => s.id === unidade.unidadeSolicitanteId).nomeFantasia

                    unidade.infraestruturaNome = this.infraestruturas
                        .find(s => s.id === unidade.unidadeSolicitanteInfraestruturaId).nome

                    unidade.infraestruturaId = this.infraestruturaId
                    unidade.unidadeId = this.unidadeId
                    unidade.unidadeTipoId = this.enums.tipoUnidade.COLETA

                    this.unidadeColeta.push(unidade)

                    this.resetForm()
                })
        },
        getPrincipal(infraestruturaPrincipal) {

            const principal = infraestruturaPrincipal.find(u => u.principal === true)
            if (principal) {
                this.unidade.unidadeSolicitanteInfraestruturaId = principal.id
            }
        },
        async validate() {

            if (this.unidade.unidadeSolicitanteId === null) {

                this.showValidationNotification('Obrigatório selecionar pelo menos uma unidade solicitante.')

                return false
            }

            if (this.unidade.unidadeSolicitanteInfraestruturaId === null) {

                this.showValidationNotification('Obrigatório selecionar o local de atendimento.')

                return false
            }

            const hasSetor = this.unidadeColeta
                .find(cc => cc.unidadeSolicitanteId === this.unidade.unidadeSolicitanteId
                    && cc.unidadeSolicitanteInfraestruturaId === this.unidade.unidadeSolicitanteInfraestruturaId)

            if (hasSetor) {

                const unidadeSolicitante = this.unidades
                    .find(s => s.id === this.unidade.unidadeSolicitanteId).nomeFantasia

                const infraestruturaNome = this.infraestruturas
                    .find(s => s.id === this.unidade.unidadeSolicitanteInfraestruturaId).nome

               this.showValidationNotification(`A unidade solicitante <strong>${ unidadeSolicitante }</strong> e o
               local de atendimento <strong>${ infraestruturaNome }</strong> já estão cadastrados.`)

               return false
            }

            return true
        },
        resetForm() {

            this.unidade.unidadeSolicitanteId = null
            this.unidade.unidadeSolicitante = ''
            this.unidade.infraestruturaNome = ''
            this.unidade.unidadeId = ''
            this.unidade.infraestruturaId = ''
            this.unidade.unidadeSolicitanteInfraestruturaId = null

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(index, item) {

            const destroy = async () => {

                const idx = this.unidadeColeta.findIndex(
                    u => u.unidadeSolicitanteId === item.unidadeSolicitanteId &&
                        u.unidadeSolicitanteInfraestruturaId === item.unidadeSolicitanteInfraestruturaId
                );
                if (idx !== -1) {
                    this.unidadeColeta.splice(idx, 1);
                }
            };

            this.showDeleteConfirmation(`Deseja realmente excluir a unidade solicitante
                <strong>${ item.unidadeSolicitante }</strong> e o  local de atendimento
                <strong>${ item.infraestruturaNome }</strong>?`,
                destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
        unidadeColeta: { type: Array, required: true },
        unidadeId: { type: Number, required: true },
        infraestruturaId: { type: Number, required: true },
        unidadeDisabled: { type: Boolean, default: false },
    },
    data: () => ({
        form: {
            unidades: {}
        },
        model: {},
        enums: {
            tipoUnidade
        },
        unidade: {
            unidadeSolicitanteId: null,
            infraestruturaId: null,
            unidadeSolicitanteInfraestruturaId: null,
            unidadeSolicitante: '',
            infraestruturaNome: '',
            unidadeId: '',
            unidadeTipoId: '',
        },
    }),
}
</script>